export const DashboardIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
      <defs />
      <rect x={0.5} y={16.5} width={10} height={7} rx={1} fill="#00e6ca" />
      <path d="M5.5,16.5h-4a1,1,0,0,0-1,1v5a1,1,0,0,0,1,1h4Z" fill="#c4f0eb" />
      <rect
        x={13.5}
        y={10.5}
        width={10}
        height={13}
        rx={1}
        transform="translate(37 34) rotate(180)"
        fill="#00e6ca"
      />
      <path d="M18.5,10.5h-4a1,1,0,0,0-1,1v11a1,1,0,0,0,1,1h4Z" fill="#c4f0eb" />
      <rect
        x={13.5}
        y={0.5}
        width={10}
        height={7}
        rx={1}
        transform="translate(37 8) rotate(180)"
        fill="#00e6ca"
      />
      <path d="M18.5.5h-4a1,1,0,0,0-1,1v5a1,1,0,0,0,1,1h4Z" fill="#c4f0eb" />
      <rect x={0.5} y={0.5} width={10} height={13} rx={1} fill="#00e6ca" />
      <path d="M5.5.5h-4a1,1,0,0,0-1,1v11a1,1,0,0,0,1,1h4Z" fill="#c4f0eb" />
      <rect
        x={0.5}
        y={16.5}
        width={10}
        height={7}
        rx={1}
        fill="none"
        stroke="#0f172a"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <rect
        x={13.5}
        y={10.5}
        width={10}
        height={13}
        rx={1}
        transform="translate(37 34) rotate(180)"
        fill="none"
        stroke="#0f172a"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <rect
        x={13.5}
        y={0.5}
        width={10}
        height={7}
        rx={1}
        transform="translate(37 8) rotate(180)"
        fill="none"
        stroke="#0f172a"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <rect
        x={0.5}
        y={0.5}
        width={10}
        height={13}
        rx={1}
        fill="none"
        stroke="#0f172a"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
